module.exports = __webpack_public_path__ + "static/41-cf15777ed208c939d4767f0f0fef373e.png";